<script lang="ts" setup>
import { List, ListInstance } from "vant";
import EmptyBoxIcon from "@/components/icon/empty/EmptyBoxIcon.vue";
import { ref } from "vue";
import i18n from "@/locales";

interface ScrollLoadingList {
  onScrollLoad?: () => Promise<boolean>;
  enableScrollLoad?: boolean;
  scroller?: Element | null;
  showBottomTip?: boolean;
  immediateCheck?: boolean;
}

const props = withDefaults(defineProps<ScrollLoadingList>(), {
  onScrollLoad: async () => false,
  enableScrollLoad: true,
  showBottomTip: true,
  immediateCheck: true,
});
// 滑动加载
const listRef = ref<ListInstance | null>(null);
const scrollLoading = ref(false);
const finished = ref(false);
const error = ref(false);
const scrollLoad = async () => {
  try {
    scrollLoading.value = true;
    const hasMore = await props.onScrollLoad();
    finished.value = !hasMore;
  } catch (e) {
    error.value = true;
    throw e;
  } finally {
    scrollLoading.value = false;
  }
};

const resetScrollLoadingState = () => {
  finished.value = false;
  error.value = false;
  listRef.value?.check();
};

export interface ScrollLoadingListInstance {
  scrollLoading: typeof scrollLoading;
  resetScrollLoadingState: typeof resetScrollLoadingState;
}

defineExpose({
  scrollLoading,
  resetScrollLoadingState,
});
</script>
<template>
  <list
    ref="listRef"
    v-model:error="error"
    v-model:loading="scrollLoading"
    :disabled="!enableScrollLoad"
    :error-text="i18n.global.t('Message.requestFailedClickToReload')"
    :finished="finished"
    :finished-text="i18n.global.t('Message.noMoreAvailable')"
    :immediateCheck="immediateCheck"
    :loading-text="i18n.global.t('Message.loading')"
    :scroller="props.scroller!"
    @load="scrollLoad"
  >
    <slot></slot>
    <template #finished>
      <div
        v-if="showBottomTip"
        class="py-4 flex flex-col justify-center items-center gap-2 text-base-content/50 text-sm"
      >
        <empty-box-icon />
        <span>{{ $t("Message.noMoreAvailable") }}</span>
      </div>
      <div v-else></div>
    </template>
  </list>
</template>
